import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { useNavigate } from "react-router-dom";
import { machineProfile, location } from "../../api";
import { printLocation } from "../../utils/helper";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Loader } from "../../utils/helper";

function MachineHealth() {
  const [locationData, setLocationData] = useState([]);
  const [selectedtedLocation, setSelectedtedLocation] = useState("");
  const [listMachine, setListMachine] = useState([]);
  const [loading, setLoading] = useState(false);
  async function getLocation() {
    const res = await location.list();
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      setLocationData(data);
    }
  }
  async function getMachine() {
    try {
      let queryParam = {};
      if (selectedtedLocation) {
        queryParam = {
          location_id: selectedtedLocation,
        };
      }
      const res = await machineProfile.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        setListMachine(data);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  }
  useEffect(() => {
    setLoading(true);
    getLocation();
    getMachine();
  }, []);
  const navigate = useNavigate();
  function handleMachineHealth(id) {
    navigate("/sensor/live/" + id);
  }

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-10">
          <div className="row">
            <div className="col-xl-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#/">MACHINE</a>
                </li>
                <li className="breadcrumb-item active">MACHINE LIST</li>
              </ul>

              <h1 className="page-header">Machine Health</h1>

              <hr className="mb-4" />

              <div id="datatable" className="mb-5">
                <div className="row mb-2 justify-content-end">
                  <div className="col-3">
                    <select
                      className="form-select btn btn-sm btn-outline-theme"
                      defaultValue=""
                    >
                      <option value="">- Filter Location -</option>
                      <option value="1">Area 1</option>
                      <option value="2">Area 2</option>
                      <option value="3">Area 3</option>
                    </select>
                  </div>
                </div>
                <div className="modal fade" id="modalLg">
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <Card>
                        <CardHeader>Machine Alert Status</CardHeader>
                        <CardBody>
                          <div
                            style={{
                              width: "100%",
                              height: "50px",
                              borderRadius: "50px",
                              background:
                                "linear-gradient(90deg, rgba(175,234,205,1) 0%, rgba(175,234,205,1) 3%, rgba(234,228,175,1) 33%, rgba(255,190,126,1) 66%, rgba(255,119,156,1) 97%, rgba(255,119,156,1) 100%)",
                            }}
                          ></div>
                        </CardBody>
                      </Card>
                    </div>
                  </div>
                </div>
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <table
                        style={{ tableLayout: "fixed" }}
                        id="datatableDefault"
                        className="table text-nowrap w-100 table-hover hover"
                      >
                        <thead className="table-dark">
                          <tr>
                            <th>Plant</th>
                            <th>Zone</th>
                            <th>Machine</th>
                            <th>Machine Brand</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listMachine.map((machine) => (
                            <tr key={machine.id}>
                              <td
                                style={{
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                <p>
                                  {printLocation(
                                    machine.location?.location_name
                                  )}
                                </p>
                              </td>
                              <td
                                style={{
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                <p>
                                  {printLocation(
                                    machine.location?.parent_location
                                      ?.location_name
                                  )}
                                </p>
                              </td>
                              <td
                                style={{
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                <p>{machine.machine_name}</p>
                              </td>
                              <td
                                style={{
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {machine.machine_brand}
                              </td>
                              <td>
                                <button
                                  onClick={() => {
                                    handleMachineHealth(machine.id);
                                  }}
                                  className="btn btn-theme btn-sm text-black"
                                >
                                  View Live Data
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MachineHealth;
